import React, { useEffect, useState } from "react";
import { Table, Space, Tooltip, Button, Switch, Card, Row, Col, message, Typography, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined, FormOutlined, PlusCircleOutlined, LockOutlined, UserOutlined } from "@ant-design/icons";
import { UtilisateurService } from "../Services/UtilisateurService";
import SideBarUser from "./SideBarUser";
import SessionModal from "./Modal_Doc/SessionModal";
import GestionPrivilegesModal from "./Modal_Doc/GestionPrivilègesModal";
import moment from "moment";

const { Title } = Typography;
const Utilisateurs = () => {
  const [tableData, setTableData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [username, setUsername] = useState("");
  const [formMode, setFormMode] = useState("");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [sessionDuration, setSessionDuration] = useState(30 * 60000); // initialDuration en millisecondes
  const [pageSize, setPageSize] = useState(10)
  const [isModalVisibleGP, setIsModalVisibleGP] = useState(false);

  const showModal = () => {
    setIsModalVisibleGP(true);
  };

  const handleCancelGP = () => {
    setIsModalVisibleGP(false);
  };

  const closeModal = () => setIsModalVisible(false);

  const saveSessionDuration = (newDuration) => {
    setSessionDuration(newDuration);
    const newDurationMinutes = newDuration / 60000; // Convertir en minutes pour le message
    message.success(`La durée de la session a été mise à jour à ${newDurationMinutes} minutes.`);
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user_connect"));
    if (user && user.username) {
      setUsername(user.username);
    }
  }, []);

  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
    setFormMode("add");
  };

  const gestionUsersService = new UtilisateurService();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await gestionUsersService.getAllUtilisateur();
        setTableData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };
    fetchData();
  }, []);

  const refreshUsers = async () => {
    try {
      const data = await gestionUsersService.getAllUtilisateur();
      setTableData(data);
    } catch (error) {
      console.error("Erreur lors de la récupération des utilisateurs:", error);
    }
  };

  const openDrawer = (user = null, mode = "") => {
    setSelectedUser(user);
    setFormMode(mode);
    setDrawerVisible(true);
  };

  const handleDelete = async (user) => {
    try {
      await gestionUsersService.deleteUser(user.login);
      setTableData((prev) => prev.filter((item) => item.login !== user.login));
    } catch (error) {
      console.error("Erreur lors de la suppression de l'utilisateur:", error);
    }
  };

  const columns = [
    {
      title: "Login",
      dataIndex: "login",
      key: "login",
      sorter: (a, b) => (String(a.login) || "").localeCompare(String(b.login) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Nom",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => (String(a.username) || "").localeCompare(String(b.username) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Email",
      dataIndex: "emailaddress",
      key: "emailaddress",
      sorter: (a, b) => (String(a.emailaddress) || "").localeCompare(String(b.emailaddress) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "État",
      dataIndex: "etat",
      key: "etat",
      align: "center",
      render: (etat) => <Switch checked={etat} />,
      sorter: (a, b) => (a.etat === b.etat ? 0 : a.etat ? 1 : -1),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Rôle",
      dataIndex: "role_name",
      key: "role_name",
      sorter: (a, b) => (String(a.role_name) || "").localeCompare(String(b.role_name) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Créer le",
      dataIndex: "pwd_date_creation",
      key: "pwd_date_creation",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => moment(text).format("DD/MM/YYYY"),
      sorter: (a, b) => {
        const valueA = new Date(a.pwd_date_creation).getTime();
        const valueB = new Date(b.pwd_date_creation).getTime();
        return valueA - valueB;
      },
    },
    {
      title: "Créer par",
      dataIndex: "created_by",
      key: "created_by",
      ellipsis: true,
      align: "center",
      width: "20px",
      render: (text) => text || " ", // Remplacer null/undefined par une chaîne vide
      sorter: (a, b) => (String(a.compte) || "").localeCompare(String(b.compte) || ""),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      align: "center",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Modifier Mot de passe">
            <LockOutlined
              onClick={() => openDrawer(record, "changePassword")}
              style={{ color: "#61dafb" }}
            />
          </Tooltip>
          <Tooltip title="Modifier">
            <EditOutlined
              onClick={() => openDrawer(record, "edit")}
              style={{ color: "#4DBD74" }}
            />
          </Tooltip>
          <Tooltip title="Supprimer">
            <Popconfirm
              title="Voulez-vous vraiment supprimer cet utilisateur ?"
              okText="Oui"
              cancelText="Non"
              onConfirm={() => handleDelete(record)}
              placement="left"
            >
              <DeleteOutlined style={{ color: "#ef2c05" }} />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];


  return (
    <>
      <div style={{ padding: 12 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "10px 20px",
            background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
            borderRadius: 10,
            boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
            marginBottom: 16,
          }}
        >
          <UserOutlined style={{ fontSize: 22, color: "#fff" }} />
          <span
            style={{
              fontSize: 18,
              fontWeight: 600,
              color: "#fff",
              letterSpacing: 0.5,
            }}
          >
            Utilisateurs
          </span>
        </div>
        <Row gutter={16}>
          <Col span={18}>
            <Table
              showSorterTooltip={false}
              dataSource={tableData}
              columns={columns}
              scroll={{
                x: true,
              }}
              pagination={{
                pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
                showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
                pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
                onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
              }}
              style={{ cursor: "pointer", whiteSpace: "wrap", width: "100%" }}
              className="custom-header1-table"
              bordered
            />
          </Col>
          <Col span={6}>
            <Card title={username}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Button
                  type="primary"
                  block
                  onClick={toggleDrawer}
                  icon={<PlusCircleOutlined />}
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'wrap',

                  }}
                >
                  Ajouter un utilisateur
                </Button>
                <Button
                  onClick={showModal}
                  style={{
                    width: '100%',
                    overflow: 'hidden',
                    whiteSpace: 'wrap',

                  }}
                >
                  Gestion des privilèges
                </Button>
                {/* <Button
        className="buttonRefresh"
        onClick={openModal}
        style={{
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'wrap',
        
        }}
      >
        Durée de la Session
      </Button> */}
              </div>
            </Card>
          </Col>


        </Row>

        <SideBarUser
          user={selectedUser}
          visible={drawerVisible}
          refreshData={refreshUsers}
          mode={formMode}
          closeDrawer={() => setDrawerVisible(false)}
          openDrawer={openDrawer}
        />

        <SessionModal
          visible={isModalVisible}
          onClose={closeModal}
          initialDuration={sessionDuration / 60000}
          onSave={saveSessionDuration}
        />

      </div>
      <GestionPrivilegesModal isVisible={isModalVisibleGP} onClose={handleCancelGP} />
    </>
  );
};

export default Utilisateurs;
